import { httpsCallable } from 'firebase/functions'

import { functions } from '@/shared/firebase/firebase.ts'
import { Reservation } from '@monorepo/functions/src/types/reservations'

export type AddReservationRequest = Omit<Partial<Reservation>, 'id'>
export type AcceptBudgetRequest = { reservationId: string }
export type ConfirmHotelReservationRequest = { reservationId: string }
export type RejectHotelReservationRequest = { reservationId: string }
export type SendHairSalonConfirmationEmailRequest = { reservationId: string }
export type SendHairSalonCancellationEmailRequest = { reservationId: string }
export type HotelReservationEmailType = 'confirmation' | 'created' | 'budget' | 'rejected'
export type SendHotelReservationEmailRequest = {
    reservationId: string
    emailType: HotelReservationEmailType
}

export const addReservation = httpsCallable<AddReservationRequest, Reservation>(functions, 'addReservation')
export const acceptBudget = httpsCallable<AcceptBudgetRequest, Reservation>(functions, 'acceptBudget')
export const confirmHotelReservation = httpsCallable<ConfirmHotelReservationRequest, Reservation>(
    functions,
    'confirmHotelReservation',
)
export const sendHairSalonConfirmationEmail = httpsCallable<SendHairSalonConfirmationEmailRequest, Reservation>(
    functions,
    'sendHairSalonConfirmationEmail',
)

export const sendHairSalonCancellationEmail = httpsCallable<SendHairSalonCancellationEmailRequest, Reservation>(
    functions,
    'sendHairSalonCancellationEmail',
)

export const sendHotelReservationEmail = httpsCallable<SendHotelReservationEmailRequest, Reservation>(
    functions,
    'sendHotelReservationEmail',
)

export const rejectHotelReservation = httpsCallable<RejectHotelReservationRequest, Reservation>(
    functions,
    'rejectHotelReservation',
)

type RecalculateClientReservationPriceRequest = { clientId: string }

export const recalculateClientReservationsPrice = httpsCallable<RecalculateClientReservationPriceRequest, void>(
    functions,
    'recalculateClientReservationsPrice',
)
